import { CookieConsentState } from '@/hooks/useCookieConsent';

// Função pura para ler consentimento diretamente (sem hooks)
function getConsentFromStorage(): CookieConsentState | null {
  try {
    const stored = localStorage.getItem('lily_cookie_consent');
    return stored ? JSON.parse(stored) : null;
  } catch {
    return null;
  }
}

export function initializeGoogleAnalytics() {
  const gaId = import.meta.env.VITE_GOOGLE_ANALYTICS_ID;

  if (!gaId || gaId === 'G-XXXXXXXXXX') {
    return;
  }

  const consent = getConsentFromStorage();

  // Se ainda não tem consentimento, não carrega GA
  if (!consent) {
    return;
  }

  // Se usuário rejeitou analytics, não carrega
  if (!consent.analytics) {
    return;
  }

  // Carregar Google Analytics script
  loadGAScript(gaId);
  configureGoogleAnalytics(gaId);
}

function configureGoogleAnalytics(gaId: string) {
  // Configurar Google Analytics global
  window.dataLayer = window.dataLayer || [];
  function gtag(...args: unknown[]) {
    window.dataLayer?.push(args);
  }
  gtag('js', new Date());
  gtag('config', gaId, {
    page_path: window.location.pathname,
    anonymize_ip: true,
  });
}

function loadGAScript(gaId: string) {
  // Verificar se script já está carregado
  if (
    document.querySelector(
      `script[src*="googletagmanager"][data-ga-id="${gaId}"]`,
    )
  ) {
    return;
  }

  const script = document.createElement('script');
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${gaId}`;
  script.setAttribute('data-ga-id', gaId);
  document.head.appendChild(script);
}

// Hook para usar GA dentro de componentes React (somente se GA foi carregado)
export function useGoogleAnalytics() {
  const trackEvent = (
    eventName: string,
    eventData?: Record<string, string | number | boolean>,
  ) => {
    if (typeof window !== 'undefined' && window.gtag) {
      window.gtag('event', eventName, eventData || {});
    }
  };

  const trackPageView = (pagePath: string) => {
    if (typeof window !== 'undefined' && window.gtag) {
      const gaId = import.meta.env.VITE_GOOGLE_ANALYTICS_ID;
      if (gaId && gaId !== 'G-XXXXXXXXXX') {
        window.gtag('config', gaId, {
          page_path: pagePath,
        });
      }
    }
  };

  return { trackEvent, trackPageView };
}
